<template>
  <div class="about-box">
    <div class="fade-out animate__animated animate__fadeOut animate__delay-2s">
      <div class="about-img mb10">
        <img src="../../assets/image/AboutUs.png" alt="">
      </div>
      <p class="aboout-title">关于我们</p>
    </div>
    <div class="fade-in">
      <div class="fade-in-top animate__animated animate__fadeInDown  animate__delay-2s">
        <div class="fade-in-img mb20">
          <img class="hidden-lg-and-down" src="../../assets/image/about-desc.png" alt="">
          <img class="hidden-xl-only hidden-sm-only hidden-xs-only" src="../../assets/image/about-desc.png" alt="">
          <img class="hidden-xl-only hidden-lg-only hidden-md-only hidden-xs-only" src="../../assets/image/about-desc-sm.png" alt="">
          <img class="hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only" src="../../assets/image/about-desc-xs.png" alt="">
        </div>
      </div>
      <div class="fade-in-line animate__animated animate__fadeIn animate__delay-2s"></div>
      <div class="animate__animated animate__fadeInUp  animate__delay-2s">
        <p class="aboout-desc">Render.G 致力于高性能的整体硬件解决方案与高效率流程管理软件相结合，并为提升整个 CGI 行业生产效率而努力。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: true,
      isActive: false,
    }
  },
  created() {
    
  },
  mounted() {
    // setTimeout(() => {
    //   this.isShow = false
    // }, 2000);
  },
  methods: {
    
  },
}
</script>